import React, { useState } from 'react';
import ClipLoader from "react-spinners/ClipLoader";
import Comm from '../comm/comm';
import tools from '../tools/tools';
import { toast } from 'react-toastify';

const EkatteEdit = (props) => {
    

    
    const [items, setItems] = useState(null);
    const [ekatteSruct, setEkatteStruct] = useState(null);
    
    if (!items) {
        tools.ReloadIfOld("ekatte", setItems);
    }





    if (!ekatteSruct) {
        Comm.Instance().get("nomenclature/EkatteStructure?ekatteId="+props.ekatteId).then(r => {
            setEkatteStruct(r.data);
        }).catch(error => tools.ProcessError(error));

    }

    const ShouldDisplay = (index) => {
        return (index === 0) || (ekatteSruct[index - 1].value !== "0")
    };


    const GetItems = (index) => {
        var currentItems = items;
        var i = 0
        while (i < index) {
            currentItems = currentItems.filter(x => x.key === ekatteSruct[i].value)[0].children;
            i++;
        }

        return currentItems;
    };

    const SetLevelValue = (index, value) => {
        ekatteSruct[index].value = value;
        for (var i = index + 1; i < ekatteSruct.length; i++) {
            ekatteSruct[i].value = "0";
        }
        setEkatteStruct([...ekatteSruct]);
        if (props.setValueId) {
            props.setValue(props.setValueId, value)
        }
        else {
        
            props.setValue(value)
        }

    };


    


    if (!ekatteSruct || !items) {
        return (
            <div className="form-group col-md-12">
                <ClipLoader
                    size={150}
                    color={"#123abc"}
                    loading={!items}
                />
            </div>
        )
    }


    return (
        <>
            <div className="form-row">
                {
                    ekatteSruct.map((item, index) =>
                        ShouldDisplay(index) ?
                            <div className="form-group col-md-3" key={index}>
                                <label>{item.name}</label>
                                <select className="form-control" value={ekatteSruct[index].value} onChange={e => SetLevelValue(index, e.target.value)} disabled={props.readonly}>
                                    <option value="0"></option>
                                    {
                                        GetItems(index).map(o => <option value={o.key} key={o.key}>{o.label}</option>)
                                    }
                                </select>
                            </div>
                            : null

                    )
                }


            </div>
        </>

    );
}


export default EkatteEdit;